/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsMapPin: {
  name: 'map-pin';
  data: string;
} = {
  name: 'map-pin',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.5 4a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0ZM12 .5a3.5 3.5 0 0 0-2.8 5.6.503.503 0 0 0-.054.046l-8.5 8.5a.5.5 0 0 0 .708.708l8.5-8.5A.504.504 0 0 0 9.9 6.8 3.5 3.5 0 1 0 12 .5Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
